import axios from 'axios';

const api = axios.create({
  baseURL: process.env.API_URL + '/npp',
  timeout: 30e3
});

export const setKey = (key: string) => {
  api.defaults.headers.Authorization = `Key ${key}`;
};

export default api;
